import { Box, IconButton, Tooltip, useClipboard } from "@chakra-ui/react";
import React from "react";
import { FiCheck, FiCopy } from "react-icons/fi";

export function CopyableInlineCode({
  value,
  copyLabel = "Copy",
}: {
  value: string;
  copyLabel?: string;
}): React.ReactElement {
  const { hasCopied, onCopy } = useClipboard(value);

  return (
    <Box
      // copyable code gets the same default styling of all `code` elements,
      // but with an additional border to make it look like a pill, and a copy
      // button.
      as="code"
      display="inline-flex"
      alignItems="stretch"
      whiteSpace="normal"
      // required to make the selector more specific than the default styling
      sx={{
        "&&": {
          display: "inline-flex",
          alignItems: "stretch",
          p: 0,
        },
      }}
      borderWidth="1px"
      borderRadius="md"
      borderColor="gray.300"
    >
      <Box
        as="span"
        display="inline-flex"
        alignItems="center"
        px={1.5}
        py={0.5}
        fontSize="1em"
        overflowWrap="anywhere"
        wordBreak="break-word"
      >
        {value}
      </Box>

      <Box
        as="span"
        alignSelf="stretch"
        borderLeftWidth="1px"
        borderLeftColor="gray.300"
      />

      <Tooltip label={hasCopied ? "Copied" : copyLabel}>
        <IconButton
          aria-label={`${copyLabel}: ${value}`}
          icon={hasCopied ? <FiCheck /> : <FiCopy />}
          size="xs"
          variant="ghost"
          fontSize="0.9em"
          color="gray.500"
          alignSelf="stretch"
          h="auto"
          minH="auto"
          borderLeftRadius={0}
          borderTopRightRadius="md"
          borderBottomRightRadius="md"
          onClick={onCopy}
        />
      </Tooltip>
    </Box>
  );
}
